<template>
  <v-container fluid class="home">
    <HomeScreen msg="Welcome to Your Vue.js App"/>
  </v-container>
</template>

<script>
// @ is an alias to /src
import HomeScreen from '@/components/HomeScreen.vue'

export default {
  name: 'Home',
  components: {
    HomeScreen
  }
}
</script>
